import { useContext } from 'react';
import { FileAssociationContext } from 'contexts/file_association_context';

const useFileAssociation = () => {
    return useContext(FileAssociationContext);
};

export default useFileAssociation;
